(function ($) {
    window.lazyLoad = function() {
        const lazyLoad = $('.lazyload')

        lazyLoad.Lazy({
            threshold: 100,
            effect: 'fadeIn',
            placeholder: '',
            afterLoad: function (element) {
                $(".image-placeholder").attr('style', 'display: none;');
            }
        });
    };
})(jQuery);